import { createContext, type ReactNode } from 'react'

export type ModalSide = 'bottom' | 'left' | 'right' | 'top'

export interface ModalData {
  id: string
}

type modalType = 'dialog' | 'sheet'

export interface ModalOptions {
  /**
   * Extra classes for the dialog popup. Mainly meant for width: the popup keeps
   * its narrow default unless a caller overrides `max-w-*`.
   */
  className?: string
}

export interface ModalContextType {
  showModal: (
    content: ReactNode,
    type?: modalType,
    data?: ModalData,
    side?: ModalSide,
    options?: ModalOptions
  ) => void
  hideModal: () => void
  currentModal: ModalData | undefined
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined)
